// extracted by mini-css-extract-plugin
export default {"card":"order-preview_card__Pz6H2"};